import PATHS from 'src/paths';
import {getTitleForPath} from 'src/utils';

export default {
  loading: 'Loading...',
  [PATHS.HOME]: 'Home',
  [PATHS.UNAVAILABLE]: 'Service temporarily unavailable',
  [PATHS.SIGN_IN]: 'Sign in to account',
  [PATHS.SIGN_UP]: 'Account registration',
  [getTitleForPath(PATHS.SIGN_UP_FROM_AGENT)]: 'Account registration',
  [PATHS.PASSWORD_SAVED]: 'Password saved!',
  [getTitleForPath(PATHS.PUBLIC_WHATSAPP_REGISTRATION)]: 'WhatsApp channel registration',
  [getTitleForPath(PATHS.PUBLIC_WHATSAPP_BUSINESS_APP_REGISTRATION)]:
    'WhatsApp Business App channel registration',
  [getTitleForPath(PATHS.PUBLIC_MAX_REGISTRATION)]: 'MAX channel registration',
  [getTitleForPath(PATHS.PUBLIC_TELEGRAM_REGISTRATION)]: 'Telegram channel registration',
  [getTitleForPath(PATHS.SIGN_IN_TENANT_BY_INVITE)]: 'Sign in',
  [getTitleForPath(PATHS.SIGN_IN_USER_BY_INVITE)]: 'Sign in',
  [PATHS.EMAIL_CONFIRM]: 'Email confirm',
  [PATHS.CHANNELS]: 'Channels',
  [getTitleForPath(PATHS.SUPPORT_CHANNELS_LIST)]: 'Channels',
  [getTitleForPath(PATHS.SUPPORT_CHANNEL_VIEW)]: 'View channel',
  [PATHS.CHANNELS_VERIFICATION_NEW]: 'Verification request',
  [getTitleForPath(PATHS.CHANNELS_VERIFICATION_EDIT)]: 'Verification request',
  [getTitleForPath(PATHS.CHANNELS_VERIFICATION_VIEW)]: 'Verification request',
  [PATHS.MESSAGE_MATCHERS]: 'Templates',
  [getTitleForPath(PATHS.SUPPORT_MESSAGE_MATCHERS_LIST)]: 'Templates',
  [getTitleForPath(PATHS.SUPPORT_MESSAGE_MATCHER_VIEW)]: 'View template',
  [PATHS.CHANNELS_WHATSAPP_NEW]: 'Create WhatsApp channel',
  [getTitleForPath(PATHS.CHANNELS_WHATSAPP_EDIT)]: 'Edit WhatsApp channel',
  [getTitleForPath(PATHS.CHANNELS_WHATSAPP_VIEW)]: 'View WhatsApp{{postfix}} channel',
  [PATHS.CHANNELS_WHATSAPP_TECH_PARTNER_NEW]: 'Create WhatsApp channel',
  [getTitleForPath(PATHS.CHANNELS_WHATSAPP_TECH_PARTNER_EDIT)]: 'Edit WhatsApp{{postfix}} channel',
  [getTitleForPath(PATHS.CHANNELS_WHATSAPP_TECH_PARTNER_VIEW)]: 'View WhatsApp{{postfix}} channel',
  [PATHS.CHANNELS_WHATSAPP_BUSINESS_APP_TECH_PARTNER_NEW]: 'Create WhatsApp Business App channel',
  [PATHS.CHANNELS_WHATSAPP_BUSINESS_APP_NEW]: 'Create WhatsApp Business App channel',
  [getTitleForPath(PATHS.CHANNELS_WHATSAPP_BUSINESS_APP_EDIT)]:
    'Edit WhatsApp Business App channel',
  [PATHS.CHANNELS_VIBER_NEW]: 'Create Viber channel',
  [getTitleForPath(PATHS.CHANNELS_VIBER_EDIT)]: 'Edit Viber channel',
  [getTitleForPath(PATHS.CHANNELS_VIBER_VIEW)]: 'View Viber channel',
  [PATHS.CHANNELS_SMS_NEW]: 'Create SMS channel',
  [getTitleForPath(PATHS.CHANNELS_SMS_EDIT)]: 'Edit SMS channel',
  [getTitleForPath(PATHS.CHANNELS_SMS_VIEW)]: 'View SMS channel',
  [PATHS.MESSAGE_MATCHERS_WHATSAPP_NEW]: 'New template',
  [getTitleForPath(PATHS.MESSAGE_MATCHERS_WHATSAPP_EDIT)]: 'Edit WhatsApp template',
  [getTitleForPath(PATHS.MESSAGE_MATCHERS_WHATSAPP_VIEW)]: 'View WhatsApp template',
  [PATHS.MESSAGE_MATCHERS_VIBER_NEW]: 'New Viber template',
  [getTitleForPath(PATHS.MESSAGE_MATCHERS_VIBER_EDIT)]: 'Edit Viber template',
  [getTitleForPath(PATHS.MESSAGE_MATCHERS_VIBER_VIEW)]: 'View Viber template',
  [PATHS.MESSAGE_MATCHERS_SMS_NEW]: 'New SMS template',
  [getTitleForPath(PATHS.MESSAGE_MATCHERS_SMS_EDIT)]: 'Edit SMS template',
  [getTitleForPath(PATHS.MESSAGE_MATCHERS_SMS_VIEW)]: 'View SMS template',
  [PATHS.MESSAGE_MATCHERS_PUSH_NEW]: 'New Push template',
  [getTitleForPath(PATHS.MESSAGE_MATCHERS_PUSH_EDIT)]: 'Edit Push template',
  [getTitleForPath(PATHS.MESSAGE_MATCHERS_PUSH_VIEW)]: 'View Push template',
  [PATHS.MESSAGE_MATCHERS_OK_NOTIFY_NEW]: 'New OK Notify template',
  [getTitleForPath(PATHS.MESSAGE_MATCHERS_OK_NOTIFY_EDIT)]: 'Edit OK Notify template',
  [getTitleForPath(PATHS.MESSAGE_MATCHERS_OK_NOTIFY_VIEW)]: 'View OK Notify template',
  [PATHS.MESSAGE_MATCHERS_VK_NOTIFY_NEW]: 'New VK Notify template',
  [getTitleForPath(PATHS.MESSAGE_MATCHERS_VK_NOTIFY_EDIT)]: 'Edit Vk Notify template',
  [getTitleForPath(PATHS.MESSAGE_MATCHERS_VK_NOTIFY_VIEW)]: 'View Vk Notify template',
  [PATHS.BROADCASTS_LIST]: 'Broadcasts',
  [getTitleForPath(PATHS.BROADCASTS_DETAILS)]: 'Broadcast details',
  [PATHS.BROADCASTS_NEW]: 'Create broadcast',
  [getTitleForPath(PATHS.BROADCASTS_EDIT)]: 'Edit broadcast',
  [PATHS.CASCADES_LIST]: 'Cascades',
  [PATHS.CASCADES_NEW]: 'Create cascade',
  [getTitleForPath(PATHS.CASCADES_VIEW)]: 'View cascade',
  [PATHS.SUBSCRIBERS_LIST]: 'Audience',
  [PATHS.SUBSCRIBERS_NEW]: 'Add recipient',
  [getTitleForPath(PATHS.SUBSCRIBERS_EDIT)]: 'Edit recipient',
  [PATHS.SUBSCRIBERS_GROUP_EDIT]: 'Add list of recipients',
  [PATHS.PROFILE]: 'My profile',
  [getTitleForPath(PATHS.NEWS)]: 'Company news',
  [PATHS.COMPANY_PROFILE]: 'Profile {{companyName}}',
  [PATHS.COMPANY_CLIENTS]: 'Leads',
  [getTitleForPath(PATHS.COMPANY_CLIENT_CARD)]: 'Lead profile',
  [getTitleForPath(PATHS.COMPANY_CLIENT_NEW)]: 'Create lead',
  [getTitleForPath(PATHS.COMPANY_CLIENT_EDIT)]: 'Create lead',
  [PATHS.COMPANY_AGENT_CLIENTS]: 'Agents',
  [getTitleForPath(PATHS.COMPANY_AGENT_CLIENT_CARD)]: 'Agent profile',
  [getTitleForPath(PATHS.COMPANY_AGENT_CLIENT_NEW)]: 'Create agent',
  [getTitleForPath(PATHS.SUPPORT_CLIENT_CARD)]: 'Company client profile',
  [getTitleForPath(PATHS.COMPANY_CLIENT_CARD)]: 'Company client card',
  [getTitleForPath(PATHS.COMPANY_CLIENT_NEW)]: 'New client',
  [getTitleForPath(PATHS.SUPPORT)]: 'Company clients',
  [PATHS.ANALYTICS_MESSAGES]: 'Message report',
  [getTitleForPath(PATHS.SUPPORT_ANALYTICS_MESSAGES)]: 'Message report',
  [PATHS.ANALYTICS_SUMMARY_REPORT]: 'Summary report',
  [getTitleForPath(PATHS.SUPPORT_ANALYTICS_SUMMARY_REPORT)]: 'Summary report',
  [getTitleForPath(PATHS.ANALYTICS_CHANNEL)]: 'Summary report',
  [getTitleForPath(PATHS.SUPPORT_ANALYTICS_CHANNEL)]: 'Summary report',
  [PATHS.ANALYTICS_MESSAGE_MATCHERS_LIST]: 'Template statistics',
  [getTitleForPath(PATHS.ANALYTICS_MESSAGE_MATCHER)]: 'Template statistics',
  [PATHS.NOTIFICATIONS]: 'Event log',
  [PATHS.HELP]: 'Help',
  [getTitleForPath(PATHS.SUPPORT_TRIGGERS_LIST)]: 'Scripts',
  [PATHS.TRIGGERS_NEW]: 'New script',
  [PATHS.TRIGGERS_LIST]: 'Scripts',
  [getTitleForPath(PATHS.TRIGGERS_EDIT)]: 'Edit script',
  [getTitleForPath(PATHS.TRIGGERS_VIEW)]: 'View script',
  [getTitleForPath(PATHS.SUPPORT_TRIGGERS_VIEW)]: 'View script',
  [PATHS.CHANNELS_PUSH_NEW]: 'Create Push channel',
  [getTitleForPath(PATHS.CHANNELS_PUSH_APP_DATA)]: 'Application data',
  [getTitleForPath(PATHS.CHANNELS_PUSH_LIST)]: 'Push channel data',
  [getTitleForPath(PATHS.CHANNELS_PUSH_APP_NEW)]: 'Setting up {{appType}} application',
  [getTitleForPath(PATHS.CHANNELS_PUSH_IOS_NEW_STEP)]: 'Setting up iOS application',
  [getTitleForPath(PATHS.CHANNELS_PUSH_IOS_EDIT)]: 'Setting up iOS application',
  [getTitleForPath(PATHS.CHANNELS_PUSH_ANDROID_NEW_STEP)]: 'Setting up Android application',
  [getTitleForPath(PATHS.CHANNELS_PUSH_ANDROID_EDIT)]: 'Setting up Android application',
  [getTitleForPath(PATHS.INTEGRATION)]: 'Integration',
  [getTitleForPath(PATHS.INTEGRATION_SETTINGS_API_KEY_NEW)]: 'Generate a new API key',
  [getTitleForPath(PATHS.INTEGRATION_SETTINGS_CALLBACK_NEW)]: 'New webhook',
  [getTitleForPath(PATHS.INTEGRATION_SETTINGS_CALLBACK_EDIT)]: 'Edit webhook parameters',
  [PATHS.FILES]: 'Downloading',
  [PATHS.CORRECTIONS]: 'Corrections',
  [PATHS.CHANNELS_VK_NOTIFY_NEW]: 'Create VK Notify channel',
  [getTitleForPath(PATHS.CHANNELS_VK_NOTIFY_EDIT)]: 'Edit VK Notify channel',
  [getTitleForPath(PATHS.CHANNELS_VK_NOTIFY_VIEW)]: 'View VK Notify channel',
  [PATHS.CHANNELS_OK_NOTIFY_NEW]: 'Create OK Notify channel',
  [getTitleForPath(PATHS.CHANNELS_OK_NOTIFY_EDIT)]: 'Edit OK Notify channel',
  [getTitleForPath(PATHS.CHANNELS_OK_NOTIFY_VIEW)]: 'View OK Notify channel',
  [PATHS.CHANNELS_MAX_BOT_NEW]: 'Create MAX Bot channel',
  [getTitleForPath(PATHS.CHANNELS_MAX_BOT_EDIT)]: 'Edit MAX Bot channel',
  [getTitleForPath(PATHS.CHANNELS_MAX_BOT_VIEW)]: 'View MAX Bot channel',
  [PATHS.CHANNELS_MAX_NEW]: 'Create MAX channel',
  [getTitleForPath(PATHS.CHANNELS_MAX_EDIT)]: 'Edit MAX channel',
  [getTitleForPath(PATHS.CHANNELS_MAX_VIEW)]: 'View MAX channel',
  [PATHS.CHANNELS_MAX_TECH_PARTNER_NEW]: 'Create MAX channel',
  [getTitleForPath(PATHS.CHANNELS_MAX_TECH_PARTNER_EDIT)]: 'Edit MAX channel',
  [getTitleForPath(PATHS.CHANNELS_MAX_TECH_PARTNER_VIEW)]: 'View MAX channel',
  [PATHS.CHANNELS_TELEGRAM_NEW]: 'Create Telegram channel',
  [getTitleForPath(PATHS.CHANNELS_TELEGRAM_EDIT)]: 'Edit Telegram channel',
  [getTitleForPath(PATHS.CHANNELS_TELEGRAM_VIEW)]: 'View Telegram channel',
  [PATHS.CHANNELS_TELEGRAM_TECH_PARTNER_NEW]: 'Create Telegram channel',
  [getTitleForPath(PATHS.CHANNELS_TELEGRAM_TECH_PARTNER_EDIT)]: 'Edit Telegram channel',
  [getTitleForPath(PATHS.CHANNELS_TELEGRAM_TECH_PARTNER_VIEW)]: 'View Telegram channel',
  [PATHS.SUPPORT_INVOICE_ASSIGN]: '[en] Зачисление платежа',
  [PATHS.SUPPORT_INVOICE_CANCEL]: '[en] Отмена платежа',
  [PATHS.AGENT_PAYMENTS]: 'Client payments',
  [PATHS.AGENT_CLIENTS]: 'My clients',
  [getTitleForPath(PATHS.AGENT_CLIENT_CARD)]: 'Client card',
  [PATHS.AGENT_PROFILE]: 'Company profile',
  [getTitleForPath(PATHS.SUPPORT_AGENT_CLIENTS)]: 'Agent’s clients',
  [getTitleForPath(PATHS.SUPPORT_AGENT_CLIENT_CARD)]: 'Agent’s clients',
  [getTitleForPath(PATHS.SUPPORT_AGENT_PAYMENTS)]: "Agent's client payments",
  [PATHS.TARIFFS]: 'Tariff catalog',
  [getTitleForPath(PATHS.TARIFF_CARD)]: 'Tariff',
  [getTitleForPath(PATHS.TARIFF_CARD_DETAIL_NEW)]: 'New tariff detail',
  [getTitleForPath(PATHS.TARIFF_CARD_DETAIL_EDIT)]: 'Edit tariff detail',
  [getTitleForPath(PATHS.TARIFF_CARD_PRICING_DETAIL_NEW)]: 'New tariff pricing detail',
  [getTitleForPath(PATHS.TARIFF_CARD_PRICING_DETAIL_EDIT)]: 'Edit tariff pricing detail',
  [getTitleForPath(PATHS.DIALOGS_MESSAGES)]: 'Dialogs',
  [PATHS.DIALOGS]: 'Dialogs',
};
